module.exports = __webpack_public_path__ + "static/media/slider6.0a24d62c.jpg";